import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterStringSearchValueObject} from './FilterStringSearchValueObject.js'

export class FilterTargetBuyerSearchValueObject extends ValueObject {
  #targetBuyer

  constructor({targetBuyer}) {
    super()
    this.#targetBuyer = targetBuyer
  }

  static normalize(targetBuyer) {
    return targetBuyer === undefined ? null : targetBuyer
  }

  static create({targetBuyer}) {
    const normalizedTargetBuyer = FilterTargetBuyerSearchValueObject.normalize(targetBuyer)
    return new FilterTargetBuyerSearchValueObject({
      targetBuyer: FilterStringSearchValueObject.create({string: normalizedTargetBuyer})
    })
  }

  static createWithDefaultValue({config, targetBuyer}) {
    return FilterTargetBuyerSearchValueObject.create({targetBuyer})
  }

  static createFromUrl({config, url = ''}) {
    const {SEMANTIC_KEYWORDS} = config.get('seo')
    const {TARGET_BUYER_IDS} = config.get('subscription')
    const isRentingForBusiness = url.startsWith(`/renting/${SEMANTIC_KEYWORDS.RENTING.TARGET_BUYER_BUSINESS}`)

    if (isRentingForBusiness) {
      return FilterTargetBuyerSearchValueObject.create({targetBuyer: TARGET_BUYER_IDS.BUSINESS})
    }

    const urlQueryParms = new URLSearchParams(url.split('?')[1] || '')
    if (urlQueryParms.has('targetBuyer')) {
      return FilterTargetBuyerSearchValueObject.create({targetBuyer: urlQueryParms.get('targetBuyer')})
    }

    return FilterTargetBuyerSearchValueObject.createWithDefaultValue({
      config,
      targetBuyer: null
    })
  }

  static createQueryParams({config, targetBuyer}) {
    const {FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')
    const normalizedTargetBuyer = FilterTargetBuyerSearchValueObject.normalize(targetBuyer)

    return new FilterTargetBuyerSearchValueObject({
      targetBuyer: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.TARGET_BUYER],
        value: normalizedTargetBuyer
      })
    })
  }

  get isEmpty() {
    return this.#targetBuyer?.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#targetBuyer?.queryParam})
    }
  }

  get value() {
    return this.#targetBuyer?.value
  }

  toJSON() {
    return {
      value: this.#targetBuyer?.toJSON()
    }
  }
}
